import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ResultGetModel, ResultTestModel } from 'data/result/result.model';

type SliceState = {
  status: 'idle' | 'loading' | 'data' | 'error';
  data: any;
  error: any;
};

const initState: SliceState = {
  error: false,
  data: [],
  status: 'idle',
};

const setLoading = (): SliceState => ({ ...initState, status: 'loading' });

const setData: CaseReducer<SliceState, PayloadAction<any>> = (_, action) => ({
  error: false,
  data: action.payload,
  status: 'data',
});

const setError: CaseReducer<SliceState, PayloadAction<any>> = (state, action) => ({
  error: action.payload,
  data: [],
  status: 'error',
});

const oldResultSlice = createSlice({
  name: 'oldresult',
  initialState: initState,
  reducers: {
    setLoading,
    setData,
    setError,
  },
});

export default oldResultSlice;
